// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMaxRolloverAmountPropertyDto
 */
export interface IMaxRolloverAmountPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IMaxRolloverAmountPropertyDto
     */
    max_rollover_amount_type?: IMaxRolloverAmountPropertyDtoMaxRolloverAmountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IMaxRolloverAmountPropertyDto
     */
    max_rollover_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IMaxRolloverAmountPropertyDto
     */
    max_rollover_irs_limit_type?: IMaxRolloverAmountPropertyDtoMaxRolloverIrsLimitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IMaxRolloverAmountPropertyDto
     */
    max_rollover_amount_type_state?: IMaxRolloverAmountPropertyDtoMaxRolloverAmountTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IMaxRolloverAmountPropertyDtoMaxRolloverAmountTypeEnum {
    UNLIMITED = 'UNLIMITED',
    IRS_LIMIT = 'IRS_LIMIT',
    CUSTOM = 'CUSTOM'
}
/**
* @export
* @enum {string}
*/
export enum IMaxRolloverAmountPropertyDtoMaxRolloverIrsLimitTypeEnum {
    HCFSA_MAX = 'HCFSA_MAX',
    HSA_MAX = 'HSA_MAX',
    DCAP_MAX = 'DCAP_MAX',
    TRANSIT_MAX = 'TRANSIT_MAX',
    PARKING_MAX = 'PARKING_MAX',
    HCFSA_EE_ER_MAX = 'HCFSA_EE_ER_MAX'
}
/**
* @export
* @enum {string}
*/
export enum IMaxRolloverAmountPropertyDtoMaxRolloverAmountTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IMaxRolloverAmountPropertyDto interface.
 */
export function instanceOfIMaxRolloverAmountPropertyDto(value: object): value is IMaxRolloverAmountPropertyDto {
    return true;
}

export function IMaxRolloverAmountPropertyDtoFromJSON(json: any): IMaxRolloverAmountPropertyDto {
    return IMaxRolloverAmountPropertyDtoFromJSONTyped(json, false);
}

export function IMaxRolloverAmountPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMaxRolloverAmountPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'max_rollover_amount_type': json['max_rollover_amount_type'] == null ? undefined : json['max_rollover_amount_type'],
        'max_rollover_amount': json['max_rollover_amount'] == null ? undefined : json['max_rollover_amount'],
        'max_rollover_irs_limit_type': json['max_rollover_irs_limit_type'] == null ? undefined : json['max_rollover_irs_limit_type'],
        'max_rollover_amount_type_state': json['max_rollover_amount_type_state'] == null ? undefined : json['max_rollover_amount_type_state'],
    };
}

export function IMaxRolloverAmountPropertyDtoToJSON(json: any): IMaxRolloverAmountPropertyDto {
    return IMaxRolloverAmountPropertyDtoToJSONTyped(json, false);
}

export function IMaxRolloverAmountPropertyDtoToJSONTyped(value?: IMaxRolloverAmountPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'max_rollover_amount_type': value['max_rollover_amount_type'],
        'max_rollover_amount': value['max_rollover_amount'],
        'max_rollover_irs_limit_type': value['max_rollover_irs_limit_type'],
        'max_rollover_amount_type_state': value['max_rollover_amount_type_state'],
    };
}

